"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const creatable_1 = __importDefault(require("react-select/creatable"));
const styled_components_1 = __importDefault(require("styled-components"));
const components = {
    DropdownIndicator: null,
};
exports.createOption = (label) => ({
    label,
    value: label,
});
const MultiSearchInputWrapper = styled_components_1.default.div `
  min-width: 20rem;
`;
exports.MultiSearch = ({ inputValue, value, onChange, onKeyUp, onInputChange, options, onKeyDown, className, onBlur, }) => {
    return (react_1.default.createElement(MultiSearchInputWrapper, { id: "table-search-wrapper" },
        react_1.default.createElement(creatable_1.default, { options: options, className: `${className || ""} w-100`, components: components, inputValue: inputValue, isClearable: true, isMulti: true, onChange: onChange, onBlur: onBlur, onInputChange: onInputChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: "Search", value: value })));
};
//# sourceMappingURL=MultiSearch.js.map